import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Observable} from 'rxjs';
import {EnvironmentService} from './enviroment.service';

@Injectable({providedIn: 'root'})
export class WebOnboardingService {

  constructor(
    private http: HttpClient,
    private envService: EnvironmentService,
  ) {}

  private baseUrl(): string {
    return this.envService.automaticAuthorizerURI() + '/web-onboarding';
  }

  private jsonHeaders(): HttpHeaders {
    return new HttpHeaders({
      'Content-Type': 'application/json',
      Accept: 'application/json',
    });
  }

  // =========================================================================
  // Link Generation (authenticated — for salespersons)
  // =========================================================================

  generateLink(): Observable<any> {
    return this.http.post<any>(
      `${this.baseUrl()}/generate-link`,
      {},
      {headers: this.jsonHeaders(), withCredentials: true},
    );
  }

  // =========================================================================
  // Token Validation (public — for clients)
  // =========================================================================

  validateToken(token: string): Observable<any> {
    return this.http.post<any>(
      `${this.baseUrl()}/validate-token`,
      {token},
      {headers: this.jsonHeaders(), withCredentials: true},
    );
  }

  // =========================================================================
  // Onboarding Flow (public — requires valid session)
  // =========================================================================

  uploadDni(frente: File, dorso: File): Observable<any> {
    const formData = new FormData();
    formData.append('frente', frente);
    formData.append('dorso', dorso);
    formData.append('source', 'WEB');
    return this.http.post<any>(
      `${this.baseUrl()}/start`,
      formData,
      {withCredentials: true},
    );
  }

  startFaceLiveness(): Observable<any> {
    return this.http.post<any>(
      `${this.baseUrl()}/face-liveness/start`,
      {},
      {headers: this.jsonHeaders(), withCredentials: true},
    );
  }

  verifyFaceLiveness(): Observable<any> {
    return this.http.post<any>(
      `${this.baseUrl()}/face-liveness/verify`,
      {},
      {headers: this.jsonHeaders(), withCredentials: true},
    );
  }

  sendSms(mobilePhone: string): Observable<any> {
    return this.http.post<any>(
      `${this.baseUrl()}/sms/send`,
      {mobilePhone},
      {headers: this.jsonHeaders(), withCredentials: true},
    );
  }

  verifySms(id: string, token: string): Observable<any> {
    return this.http.post<any>(
      `${this.baseUrl()}/sms/verify`,
      {id, token},
      {headers: this.jsonHeaders(), withCredentials: true},
    );
  }

  sendEmailCode(email: string): Observable<any> {
    return this.http.post<any>(
      `${this.baseUrl()}/email/send`,
      {email},
      {headers: this.jsonHeaders(), withCredentials: true},
    );
  }

  verifyEmailCode(id: string, token: string): Observable<any> {
    return this.http.post<any>(
      `${this.baseUrl()}/email/verify`,
      {id, token},
      {headers: this.jsonHeaders(), withCredentials: true},
    );
  }

  saveAddress(data: {token: string; location: any; unit?: string}): Observable<any> {
    return this.http.post<any>(
      `${this.baseUrl()}/address`,
      data,
      {headers: this.jsonHeaders(), withCredentials: true},
    );
  }

  uploadServices(files: File[], token: string): Observable<any> {
    const formData = new FormData();
    formData.append('token', token);
    files.forEach((file, index) => {
      formData.append(`service${index + 1}`, file);
    });
    return this.http.post<any>(
      `${this.baseUrl()}/services`,
      formData,
      {withCredentials: true},
    );
  }

  saveReferences(data: {token: string; references: any[]; password?: string}): Observable<any> {
    return this.http.post<any>(
      `${this.baseUrl()}/references`,
      data,
      {headers: this.jsonHeaders(), withCredentials: true},
    );
  }
}
